import React from 'react';
import { motion } from 'framer-motion';
interface GamerButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  href?: string;
  scrollTo?: string;
  children: React.ReactNode;
}
export function GamerButton({
  variant = 'primary',
  fullWidth = false,
  href,
  scrollTo,
  children,
  className = '',
  ...props
}: GamerButtonProps) {
  const baseStyles = 'relative font-orbitron font-bold uppercase tracking-wider transition-all duration-300 transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-gamer-red text-white shadow-neon-red hover:shadow-neon-red-hover hover:bg-red-600 border border-transparent',
    secondary: 'bg-transparent text-gamer-red border-2 border-gamer-red hover:bg-gamer-red/10 shadow-neon-red'
  };
  const widthStyles = fullWidth ? 'w-full' : 'w-auto';
  const sizeStyles = 'py-4 px-8 text-lg md:text-xl rounded-sm clip-path-slant';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    } else if (href) {
      // Fire Meta Pixel AddToCart event before redirecting to Shopify
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'AddToCart', {
          content_name: 'Dominio Total en Free Fire',
          content_type: 'product',
          value: 9.0,
          currency: 'USD'
        });
      }
      window.open(href, '_blank');
    }
    if (props.onClick) props.onClick(e);
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`${baseStyles} ${variants[variant]} ${widthStyles} ${sizeStyles} ${className}`} {...props} onClick={handleClick} data-id="element-223">
      {children}
    </motion.button>;
}